<template>
	<div class="d21-product-item">
		<Plusminus :value="service.Count" :minValue="0" :maxValue="service.MaxNumberOfTickets" @input="(val) => service.Count = val" :disabled="service.isDisabled" />
		<span class="d21-product-name" :class="{disabled:service.isDisabled}">{{ V(service,"Content.Name", "display_name") }}</span>
		<span v-if="showSums" class="d21-product-price" :class="{disabled:service.isDisabled}">
			{{ getDuration() }} | {{ formatPrice(service.Total, Channel) }}
		</span>
		<span v-else class="d21-product-price" :class="{disabled:service.isDisabled}">
			{{ getDuration() }}
		</span>
		<span v-if="service.isDisabled" v-html="T('disabled_product')" class="d21-product-disabled"></span>
		<div class="d21-product-shortdescription" v-if="showShortDescription">
			<span v-html="urlify(service.Content.ShortDescription)"></span>
			<a v-if="service.Content.Description !== null && service.Content.Description.trim() !== ''" class="d21-product-expand" @click="toggleDescription">{{ T("ticketing_more_informations") }}</a>
		</div>

		<div class="d21-product-description" v-else-if="showDescription">
			<span v-html="urlify(service.Content.Description)"></span>
			<template v-if="service.Documents && service.Documents.length > 0">
				<br /><br />{{ T("ticketing_required")}}<br />
				<ul>
					<li v-for="document in service.Documents" :key="document._uuid">
					{{ V(document,"Content.Name") }}
					<a v-if="document.URI !== null" :href="'https://api-default.tocc.dirs21.de/v1/cdn' + document.URI" target="imprint">{{ T("Download") }}</a>
				</li>
				</ul>

			</template>
			<a class="d21-product-collapse" @click="toggleDescription">{{ T("less_informations")}}</a>
		</div>
	</div>
</template>

<script>
	import baseMixin from "@/mixins/base";
	import Plusminus from "../ui/plusminus.vue";

	export default {
		mixins: [baseMixin],
		components: {
			Plusminus
		},
		props: {
			service: {
				type: Object,
				required: true,
			},
			showSums: {
				type: Boolean,
			}
		},
		methods: {
			urlify(description) {
				// handle whitespace: newlines and tabs
				description = description.replaceAll(/\n/g, " <br> ");
				description = description.replaceAll(/\t/g, "&emsp;");
				description = description.replaceAll("<br />", " <br> ");
				description = description.replaceAll("<br/>", " <br> ");
				description = description.replaceAll("<span>", " ");
				description = description.replaceAll("</span>", " ");

				// make urls in the description clickable 
				const regex = /(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?([\\#?&\\/\\/]\S*)?$/g;
				var words = description.split(/\s+/);
				var sentence = "";
				words.forEach(word => {
					if (regex.test(word) && !word.startsWith("href")) {
						// add scheme so external links work
							if (!word.startsWith("http")) {
								word = "https://" + word;
							}
							sentence += '<a target="_blank" href="' + word + '">' + word + '</a> ';
						
					} else {
						sentence += word + " ";
					}
				});
				// console.log(sentence);
				return sentence;
			},
			getDuration() {
				let output = "";
				if (this.service.Duration <= 0) return " 0 min ";
				if (this.getDays() > 0) output += this.getDays() + " d ";
				if (this.getPartialHours() > 0) output += this.getPartialHours() + " h ";
				if (this.getPartialMinutes() > 0) output += this.getPartialMinutes() + " min ";
				return output;
			},
			getPartialMinutes() {
				return this.service.Duration % 60
			},
			getPartialHours() {
				return Math.floor(this.service.Duration / 60) % 24
			},
			getDays() {
				return Math.floor(this.service.Duration / 1440)
			},
			toggleDescription() {
				this.service.showDescription = !this.service.showDescription;
			}
		},
		computed: {
			showShortDescription() {
				return !this.service.showDescription && this.service.Content.ShortDescription !== null && this.service.Content.ShortDescription.trim() !== '';
			},
			showDescription() {
				return this.service.showDescription && this.service.Content.Description !== null && this.service.Content.Description.trim() !== '';
			}
		},
		watch: {
			"service.Count": {
				handler() {
					this.$emit("selected");
				}
			}
		},

	}
</script>